module.exports = __webpack_public_path__ + "static/media/bg_9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg_9.png
// module id = 54
// module chunks = 0